import { render, staticRenderFns } from "./BorrarInscripcionDialog.vue?vue&type=template&id=2c503aec&"
import script from "./BorrarInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./BorrarInscripcionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports